<script lang="ts">
	//UI
	import { AlignLeft, DefaultSwitch } from "@hitit/new_ui";
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	import storeDefaultImg from "@hitit/mbr/public/Icons/selfOrderStoreDefaultIcon.png";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import ProductItem from "./ProductItem.svelte";
	import { formatNumber } from "@hitit/utils";
	//Types
	import type { CategoryData, StoreItemData } from "@hitit/api/src/types";
	//Props
	export let modalClose: () => void;
	export let categories: CategoryData[];
	export let editmode: boolean;
	//Constants
	//Variables
	let loading = false;
	let selectedItem: StoreItemData[];
	let selectedCategoryName = "";
	let selectedCategoryId = "";
	let available = false;
	//Functions

	function selectedCategory(index: number) {
		selectedItem = categories[index].storeItemDTOs;
		selectedCategoryId = categories[index].id || "";
		selectedCategoryName = categories[index].translationDTOs[0].name;
	}

	function selfOrderFunctionChangeHandler(e: Event) {
		const target = e.target as HTMLInputElement;
		available = target.checked ? true : false;
	}

	//Do
	selectedCategory(0);
	selectedCategoryName = categories[0].translationDTOs[0].name;
	console.log("categories", categories);
	$: console.log("selectedItem", selectedItem);
</script>

<div class="modal-background" t-id="MainProductModal">
	<div class="modal-container">
		<img class="modal-close" src={closeBtn} alt="close" on:click={modalClose} />
		<div class="modal-wrapper">
			<span class="title">{$t("mbr.self_order.representative_products")}</span>
			<div class="category-box">
				{#each categories as category, index}
					<span
						on:click={() => selectedCategory(index)}
						class:selected={categories[index].id === selectedCategoryId}
						>{category.translationDTOs[0].name} ({category.storeItemDTOs
							.length})</span
					>
				{/each}
			</div>
			{#if editmode}
				<div class="top-wrapper">
					<DefaultSwitch
						checked={available}
						on:change={selfOrderFunctionChangeHandler}
					/>
					<span class="menu-name">{selectedCategoryName}</span>
					<span class="selected-number">총 20개 선택</span>
				</div>
				<div class="item-wrapper">
					{#each selectedItem as item}
						<ProductItem item={item} />
					{/each}
				</div>
			{:else}
				<div class="top-wrapper">
					<span class="menu-name"
						>{selectedCategoryName} ({selectedItem.length})</span
					>
				</div>
				<div class="item-wrapper">
					{#each selectedItem as item}
						<div class="view-mode-box">
							<div class="img-box">
								<img alt="" src={storeDefaultImg} />
							</div>
							<div class="view-item-info">
								<div class="icon-wrapper">
									<div class="icon">
										<AlignLeft />
										<!-- <ImgViewIcon /> -->
									</div>
								</div>
								<span class="item-name">{item.translationDTOs[0].name}</span>
								<span class="item-price">{formatNumber(item.price)}원</span>
							</div>
						</div>
					{/each}
				</div>
			{/if}
		</div>
		{#if editmode}
			<button class="done">완료</button>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../../../variables.scss";
	.modal-background {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(70, 71, 75, 0.7);
		z-index: 1000;
	}

	.modal-wrapper {
		/* max-width: 960px; */
		overflow: hidden;
		/* margin-bottom: 25px; */
	}

	.modal-container {
		position: absolute;
		display: flex;
		flex-direction: column;
		/* overflow-y: auto; */
		/* justify-content: center; */
		/* min-width: 740px;
		max-width: 963px; */
		width: 86%;
		/* height: 800px;
		max-height: 1000px; */
		top: 60px;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		margin-bottom: 10px;
		background-color: white;
		border-radius: 5px;
		padding: 10px;

		.title {
			@include appleAdjustTextForSize(20);
			/* font-size: 34px; */
			font-weight: 500;
		}

		.category-box {
			display: flex;
			gap: 20px;
			overflow: scroll;
			margin-top: 20px;
			padding-bottom: 2px;

			&::-webkit-scrollbar {
				height: 1px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}
			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}

			span {
				min-width: fit-content;
				@include appleAdjustTextForSize(16);
				font-weight: 400;
				color: #6d6f76;
				cursor: pointer;

				&.selected {
					color: #3c68d6;
				}
			}
		}

		.top-wrapper {
			display: flex;
			align-items: center;
			gap: 10px;
			margin-top: 20px;

			.menu-name {
				@include appleAdjustTextForSize(20);
				/* font-size: 34px; */
				font-weight: 550;
				color: #46474b;
			}

			.selected-number {
				font-size: 20px;
				margin-left: auto;
				color: #6d6f76;
			}
		}

		.item-wrapper {
			display: flex;
			flex-wrap: wrap;
			/* min-height: 500px; */
			height: 72%;
			gap: 10px;
			margin-top: 10px;
			overflow-y: auto;
			padding-right: 5px;

			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}
			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}

			.view-mode-box {
				display: flex;
				width: 304px;
				height: 137px;
				background-color: #f0f0f4;
				border-radius: 5px;

				.img-box {
					display: flex;
					justify-content: center;
					align-items: center;
					min-width: 110px;
					height: 137px;
					img {
						width: 60px;
						height: 40px;
					}
				}

				.view-item-info {
					position: relative;
					display: flex;
					flex-direction: column;
					gap: 35px;
					width: 100%;
					padding: 20px;

					.icon-wrapper {
						position: absolute;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 26px;
						height: 26px;
						top: 0;
						right: 0;
						background-color: #d8d9df;
						border-radius: 0 5px;

						.icon {
							width: 14px;
							height: 14px;
							margin-bottom: 1px;
							margin-left: 1px;
						}
					}

					.item-name {
						@include appleAdjustTextForSize(20);
						font-weight: 500;
						color: #46474b;
					}
					.item-price {
						font-size: 20px;
						color: #46474b;
					}
				}
			}

			.item-box {
				width: 300px;
				height: 460px;
				border-radius: 5px;
				border: 1px solid #6591fa;

				.img-box {
					width: 300px;
					height: 300px;
					background-color: red;
				}

				img {
					width: 300px;
					height: 300px;
				}
			}
		}

		.modal-close {
			position: absolute;
			top: -43px;
			right: 0px;
			width: 30px;
			height: 30px;
			cursor: pointer;
		}

		.done {
			display: flex;
			justify-content: center;
			align-items: center;
			min-height: 40px;
			border: 0;
			color: white;
			@include appleAdjustTextForSize(20);
			font-weight: 400;
			background-color: #6591fa;
			border-radius: 5px;
		}
	}
	@include DesktopSize {
		.modal-container {
			position: absolute;
			display: flex;
			flex-direction: column;
			min-width: 740px;
			max-width: 963px;
			width: 80%;
			/* height: 800px; */
			height: 90%;
			max-height: 1000px;
			top: 0;
			padding: 30px;

			.title {
				font-size: 34px;
			}

			.category-box {
				gap: 30px;
				margin-top: 30px;

				span {
					@include appleAdjustTextForSize(16, false);
				}
			}

			.top-wrapper {
				.menu-name {
					font-size: 34px;
				}
			}

			.item-wrapper {
				min-height: 500px;
				height: 76%;
				gap: 20px;
				margin-top: 20px;

				.view-mode-box {
					.view-item-info {
						.item-name {
							@include appleAdjustTextForSize(20, false);
						}
					}
				}
			}

			.modal-close {
				top: 0;
				right: -60px;
				width: 40px;
				height: 40px;
			}

			.done {
				font-size: 1.25rem;
			}
		}
	}
</style>
